export default "__VITE_ASSET__be0c42ca__"